import jwt from "jwt-decode";

export const createQueryParams = (params) =>
  Object.keys(params)
    .filter((key) => params[key] !== undefined && params[key] !== null)
    .map((key) =>
      Array.isArray(params[key])
        ? params[key].length
          ? params[key]
              .map(function (el, idx) {
                return `${key}[` + idx + "]=" + el;
              })
              .join("&")
          : `${key}=`
        : key + "=" + params[key]
    )
    .join("&");

export const isDev = () =>
  !process.env.NODE_ENV || process.env.NODE_ENV === "development";

export const generateUrl = (path) => window.urlWebDefault + path;

// Funciones reutilizadas de la implementación anterior.
// TODO: cleanup

export const formatRut = (value, useThousandsSeparator) => {
  const rutAndDv = splitRutAndDv(value);
  let cRut = rutAndDv[0];
  const cDv = rutAndDv[1];
  if (!(cRut && cDv)) {
    return cRut || value;
  }
  var rutF = "";
  var thousandsSeparator = useThousandsSeparator ? "." : "";
  while (cRut.length > 3) {
    rutF = thousandsSeparator + cRut.substr(cRut.length - 3) + rutF;
    cRut = cRut.substring(0, cRut.length - 3);
  }
  return cRut + rutF + "-" + cDv;
};

export const isRutValid = (value) => {
  if (!value || value.trim().length < 3) return false;
  const rutLimpio = value.replace(/[^0-9kK-]/g, "");

  if (rutLimpio.length < 3) return false;

  const split = rutLimpio.split("-");
  if (split.length !== 2) return false;

  const num = parseInt(split[0], 10);
  const dgv = split[1];

  const dvCalc = calculateDV(num);
  return dvCalc === dgv.toUpperCase();
};

export const cleanRut = (value) =>
  value
    .replace(
      /\s|[qwertyuiopasdfghjlñzxcvbnmQWERTYUIOPASDFGHJLÑZXCVBNM]|\W|[¨_$%^&*()Ç·/¿?/=/"!¡ª·:]$/g,
      ""
    )
    .toUpperCase();

function splitRutAndDv(rut) {
  var cValue = rut.replace(/[\.\-]/g, "");
  if (cValue.length === 0) {
    return [null, null];
  }
  if (cValue.length === 1) {
    return [cValue, null];
  }
  var cDv = cValue.charAt(cValue.length - 1);
  var cRut = cValue.substring(0, cValue.length - 1);
  return [cRut, cDv];
}

function calculateDV(rut) {
  const cuerpo = `${rut}`;
  // Calcular Dígito Verificador
  let suma = 0;
  let multiplo = 2;

  // Para cada dígito del Cuerpo
  for (let i = 1; i <= cuerpo.length; i++) {
    // Obtener su Producto con el Múltiplo Correspondiente
    const index = multiplo * cuerpo.charAt(cuerpo.length - i);

    // Sumar al Contador General
    suma += index;

    // Consolidar Múltiplo dentro del rango [2,7]
    if (multiplo < 7) {
      multiplo += 1;
    } else {
      multiplo = 2;
    }
  }

  // Calcular Dígito Verificador en base al Módulo 11
  const dvEsperado = 11 - (suma % 11);
  if (dvEsperado === 10) return "K";
  if (dvEsperado === 11) return "0";
  return `${dvEsperado}`;
}

export const get_access_token = () =>
  localStorage.getItem("currentUser")?.replace('"', "");

export const get_request_token = () => {
  const raw_token = get_access_token();
  return raw_token ? jwt(raw_token)?.nameid : null;
};
